import React from "react";
import ImageFileIdUpload from "./ImageFileIdUpload";
const ImageFileUploadFileId = (props) => {
  const {
    placeholder,
    label,
    meta: { touched, error },
    fileurl,
    input,
  } = props;
  return (
    <ImageFileIdUpload
      label={label}
      onChange={input.onChange}
      value={input.value}
      placeholder={placeholder}
      touched={touched}
      error={error}
      input={{ ...input }}
    />
  );
};

export default ImageFileUploadFileId;
